/** Détourage automatique : rend transparent le fond blanc d'un logo en partant des BORDS
 *  (remplissage par diffusion), pour préserver les blancs intérieurs (textes, détails). */
const detourCache = new Map();

export function detourLogo(url) {
  if (!detourCache.has(url)) {
    detourCache.set(
      url,
      new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          try {
            const scale = Math.min(1, 400 / Math.max(img.naturalWidth, img.naturalHeight));
            const c = document.createElement("canvas");
            c.width = Math.max(1, Math.round(img.naturalWidth * scale));
            c.height = Math.max(1, Math.round(img.naturalHeight * scale));
            const ctx = c.getContext("2d");
            ctx.drawImage(img, 0, 0, c.width, c.height);
            const d = ctx.getImageData(0, 0, c.width, c.height);
            const px = d.data;
            const W = c.width;
            const H = c.height;
            const isWhite = (i) => Math.min(px[i], px[i + 1], px[i + 2]) >= 235;
            // Diffusion depuis les bords : seuls les blancs connectés au bord deviennent transparents
            const bg = new Uint8Array(W * H);
            const queue = [];
            const push = (x, y) => {
              const p = y * W + x;
              if (!bg[p] && isWhite(p * 4)) {
                bg[p] = 1;
                queue.push(p);
              }
            };
            for (let x = 0; x < W; x++) { push(x, 0); push(x, H - 1); }
            for (let y = 0; y < H; y++) { push(0, y); push(W - 1, y); }
            while (queue.length) {
              const p = queue.pop();
              const x = p % W;
              const y = (p - x) / W;
              if (x > 0) push(x - 1, y);
              if (x < W - 1) push(x + 1, y);
              if (y > 0) push(x, y - 1);
              if (y < H - 1) push(x, y + 1);
            }
            for (let p = 0; p < W * H; p++) {
              if (bg[p]) px[p * 4 + 3] = 0;
            }
            // Adoucit le liseré : pixels clairs accolés au fond → semi-transparents
            for (let p = 0; p < W * H; p++) {
              const i = p * 4;
              if (px[i + 3] === 0) continue;
              const lightest = Math.min(px[i], px[i + 1], px[i + 2]);
              if (lightest < 226) continue;
              const x = p % W;
              const y = (p - x) / W;
              const touchesBg =
                (x > 0 && bg[p - 1]) || (x < W - 1 && bg[p + 1]) || (y > 0 && bg[p - W]) || (y < H - 1 && bg[p + W]);
              if (touchesBg) px[i + 3] = Math.round((255 * (242 - lightest)) / 16);
            }
            ctx.putImageData(d, 0, 0);
            resolve(c.toDataURL("image/png"));
          } catch {
            resolve(url);
          }
        };
        img.onerror = () => resolve(url);
        img.src = url;
      })
    );
  }
  return detourCache.get(url);
}
